import React from 'react';
import styled from 'styled-components';
import { graphql, Link, useStaticQuery } from 'gatsby';
import Img from './Img';

const LogoStyles = styled.div`
  text-transform: uppercase;
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: center;
  align-items: center;
  grid-gap: 1rem;
  padding: 0rem;
  font-size: 2rem;
  --scale: 0;

  p::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -0.5px;
    left: 0px;
    background: var(--linkHover);
    transition: transform 0.3s ease 0s;
    transform: scale(var(--scale));
  }

  a {
    display: grid;
    justify-items: center;
    text-decoration: none;

    font-weight: bold;
    margin-right: 0;
    padding: 0;
    padding-right: 0.3rem;

    &:hover {
      --scale: 1;
    }

    p {
      position: relative;
      font-size: 0.5em;
      /* padding-top: 0.3rem; */
      margin: 0.5rem 0 0 0;
      &:hover {
        --scale: 1;
      }
      &:after {
        transform: scale(var(--scale));
      }
    }

    .gatsby-image-wrapper {
      width: 3rem;
    }
  }
`;

export default function Logo() {
  const data = useStaticQuery(graphql`
    query {
      beeIcon: file(relativePath: { eq: "bee.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      shellIcon: file(relativePath: { eq: "shell.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      nutIcon: file(relativePath: { eq: "hazelnut.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `);

  return (
    <LogoStyles>
      <Link to="/" className="center">
        <Img image={data.beeIcon} alt="Bee Icon" />
        <p>Bradley</p>
      </Link>
      <Link to="/" className="center">
        <Img image={data.shellIcon} alt="Shell Icon" />
        <p>Shell</p>
      </Link>
      <Link to="/" className="center">
        <Img image={data.nutIcon} alt="Nut Icon" />
        <p>Nut</p>
      </Link>
    </LogoStyles>
  );
}
